module.exports = __webpack_public_path__ + "img/bg_festa3.7fbc6487.jpg";